<template>
  <div>
    <b-row>
      <!-- first name -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="First Name"
          label-for="v-first-name"
        >
          <b-form-input
            id="v-first-name"
            v-model="dataForm.firstname"
            placeholder="First Name"
          />
        </b-form-group>
      </b-col>

      <!-- last name -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Last Name"
          label-for="v-last-name"
        >
          <b-form-input
            id="v-last-name"
            v-model="dataForm.lastname"
            placeholder="Last Name"
          />
        </b-form-group>
      </b-col>

      <!-- first name -->
      <b-col
        v-if="edit"
        md="6"
        sm="12"
      >
        <b-form-group
          label="Username"
          label-for="v-username"
        >
          <b-form-input
            id="v-username"
            v-model="dataForm.username"
            placeholder="Username"
            readonly
          />
        </b-form-group>
      </b-col>

      <!-- last name -->
      <b-col
        v-if="edit"
        md="6"
        sm="12"
      >
        <b-form-group
          label="Password"
          label-for="v-password"
        >
          <b-form-input
            id="v-password"
            v-model="dataForm.password"
            type="password"
            placeholder="Password"
          />
        </b-form-group>
      </b-col>

      <!-- email -->
      <b-col
        md="4"
        sm="12"
      >
        <b-form-group
          label="Email"
          label-for="v-email"
        >
          <b-form-input
            id="v-email"
            v-model="dataForm.email"
            type="email"
            placeholder="Email"
          />
        </b-form-group>
      </b-col>

      <!-- mobile -->
      <b-col
        md="4"
        sm="12"
      >
        <b-form-group
          label="Phone Number"
          label-for="v-phone-number"
        >
          <b-form-input
            id="v-phone-number"
            v-model="dataForm.phone"
            type="number"
            placeholder="Phone Number"
          />
        </b-form-group>
      </b-col>

      <!-- password -->
      <b-col
        md="4"
        sm="12"
      >
        <b-form-group
          label="Citizen ID"
          label-for="v-citizen-id"
        >
          <b-form-input
            id="v-citizen-id"
            v-model="dataForm.citizen_id"
            type="number"
            placeholder="Citizen ID"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BCard, BButton, BFormTextarea, BImg
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Ripple from 'vue-ripple-directive'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import PopupCredential from '@/views/component/PopupCredential.vue'

extend('required', {
  ...required,
  message: 'This is required!',
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    BImg,
    BCard,
    BButton,
    ValidationProvider,
    ValidationObserver,
    PopupCredential,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataForm: Object,
    edit: Boolean,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      role: this.$store.state.auth.userData.data.Account.role_id,
      statusApprove: this.$store.state.account.statusApprove,
      imgPdf: require('@/assets/images/pdf.png'),
    }
  },
  beforeMount() {
    this.resetCredential()
  },
  computed: {
    ...mapGetters('account', {
      clientId: 'getClientId',
      telcoClientId: 'getTelcoClientId',
      telcoClientSecret: 'getTelcoClientSecret',
    }),
    inputTelcoClientId: {
      get() {
        return this.telcoClientId
      },
      set(val) {
        this.setTelcoClientId(val)
      },
    },
    inputTelcoClientSecret: {
      get() {
        return this.telcoClientSecret
      },
      set(val) {
        this.setTelcoClientSecret(val)
      },
    },
  },
  mounted() {
    //
  },
  methods: {
    ...mapActions('account', ['setTelcoCredential', 'resetCredential']),
    ...mapMutations('account', {
      setTelcoClientId: 'SET_TELCO_CLIENT_ID',
      setTelcoClientSecret: 'SET_TELCO_CLIENT_SECRET',
    }),
    handleSetCredential() {
      this.$refs.credential.validate().then((res) => {
        if(res === true) {
          this.setTelcoCredential().then((response) => {
            if (response.data.status) {
              this.success()
            } else {
              // const type = (response.data.status === 1) ? 1 : 2
              this.failed(response.data)
            }
          })
        }
      })
    },
    success() {
      this.$swal({
        title: 'Success!',
        text:
          'Set credential success',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: 'account-partner' })
        }
      })
    },
    failed() {
      this.$swal({
        title: 'Failed!',
        text: '',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      })
    },
    setCredentialUpdate() {
      this.$refs.credential.validate().then((res) => {
        if(res === true) {
          this.$refs.PopupCredentialStatus.showModal()
        }
      })
    }
  }
}
</script>
<style scoped>
</style>